import React from 'react';
import './StatCard.css';

// Añadimos 'changeText' y 'changeType' a las props
function StatCard({ title, value, icon, changeText, changeType }) {
    return (
        <div className="dp-stat-card dp-neumorphic">
            <div className="dp-stat-header">
                <span className="dp-stat-title">{title}</span>
                <div className="dp-stat-icon dp-neumorphic-flat">{icon}</div>
            </div>
            <div className="dp-stat-value">{value}</div>
            
            {/* --- ESTA ES LA NUEVA SECCIÓN --- */}
            {/* Solo se muestra si le pasamos el prop 'changeText' */}
            {changeText && (
                <div className={`dp-stat-change ${changeType === 'positive' ? 'dp-positive' : 'dp-negative'}`}>
                    <span>{changeType === 'positive' ? '↗' : '↘'}</span>
                    <span>{changeText}</span>
                </div>
            )}
        </div>
    );
}

export default StatCard;